'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { IconButton } from '@s7/ui';
import { SOCIAL_ITEM_VARIANTS } from './FooterSocialItem.contract.js';
import { FooterSocialItemIcon } from './FooterSocialItemIcon.js';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FooterSocialItem = function(props) {
    var variant = props.variant, link = props.link, others = _object_without_properties_loose(props, [
        "variant",
        "link"
    ]);
    var unpackLink = useLinkOverride();
    if (!SOCIAL_ITEM_VARIANTS.includes(variant)) {
        return null;
    }
    return /*#__PURE__*/ jsx(IconButton, _extends({
        leftSide: /*#__PURE__*/ jsx(FooterSocialItemIcon, {
            variant: variant
        }),
        size: "md1",
        variant: "secondary"
    }, unpackLink(link), others));
};

export { FooterSocialItem };
